import pino from 'pino';

const isLocalDevelopment =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const logger = pino({
  browser: {
    asObject: true,
  },
  level: isLocalDevelopment ? 'debug' : 'info',
});

export default logger;
